import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { Text } from '@interco/inter-ui/components/Text'

export const HeaderSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const DescriptionSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 24px 20px;
  margin-bottom: 8px;
  gap: 16px;
`

export const DescriptionSectionBR = styled.section`
  display: flex;
  flex-direction: column;
  padding: 16px 20px 0px 20px;
  gap: 6px;

  a {
    text-decoration: none;
  }
`

export const ProductIconAndNameContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 12px;
`

export const TitleSectionContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const ProductsMenuContainer = styled.section`
  > a {
    border-bottom: 1px solid var(--gray200);

    &:last-child:not(:only-child) {
      border-bottom: none;
    }
  }
`

export const ProducsSectionTitle = styled(Text)`
  margin-top: 24px;
`

export const ProductPageLink = styled(Link)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  min-height: 56px;

  span {
    flex: 1;
  }
`
export const ProductDescriptionArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin-top: 0.5rem;
`

export const ContentArea = styled.div`
  padding: 0 1.25rem;
`

export const ProductContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: left;
  gap: 6px;
`
